module.exports = __webpack_public_path__ + "static/media/port3.66fa944a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/port3.jpg
// module id = 5837
// module chunks = 0